import { Type } from '../../types/type';
/**
 * Creates a validator function that checks that the value is of a given type.
 * @param type The type that the value must be.
 */
export const validateType = (type) => {
    return (value, logger, logLabel) => {
        const valid = isType(type, value);
        if (!valid)
            logger(`${logLabel} must be of type '${type}'.`);
        return valid;
    };
};
/**
 * Creates a validator function that checks that the value is a `boolean`.
 */
export function validateBoolean() {
    return validateType(Type.Boolean);
}
/**
 * Creates a validator function that checks that the value is a `Function`.
 */
// eslint-disable-next-line @typescript-eslint/ban-types
export function validateFn() {
    return validateType(Type.Function);
}
/**
 * Creates a validator function that checks that the value is of a given type.
 * @param type The type that the value must be.
 */
export function validateOfType(type) {
    return validateType(type);
}
/**
 * Creates a validator function that checks that the value is a `Symbol`.
 */
export function validateSymbol() {
    return validateType(Type.Symbol);
}
export const isType = (type, value) => {
    switch (type) {
        case Type.Array:
            return isArray(value);
        case Type.Date:
            return isDate(value);
        case Type.Element:
            return isElement(value);
        case Type.Error:
            return isError(value);
        case Type.Map:
            return isMap(value);
        case Type.Number:
            return isNumber(value);
        case Type.Null:
            return isNull(value);
        case Type.Object:
            return isObject(value);
        case Type.Promise:
            return isPromise(value);
        case Type.RegExp:
            return isRegExp(value);
        case Type.Set:
            return isSet(value);
        case Type.WeakSet:
            return isWeakSet(value);
        case Type.WeakMap:
            return isWeakMap(value);
        default:
            return typeof value === type.toLowerCase();
    }
};
export const isArray = (value) => Array.isArray(value);
export const isDate = (value) => value instanceof Date;
export const isElement = (value) => value instanceof Element;
export const isError = (value) => value instanceof Error && typeof value.message !== 'undefined';
export const isMap = (value) => value instanceof Map;
export const isNumber = (value) => typeof value === 'number' && !isNaN(value);
export const isNull = (value) => value === null;
export const isObject = (value) => typeof value === 'object' && value !== null && value.constructor === Object;
export const isPromise = (value) => value instanceof Promise;
export const isRegExp = (value) => !!value && typeof value === 'object' && value.constructor === RegExp;
export const isSet = (value) => value instanceof Set;
export const isWeakSet = (value) => value instanceof WeakSet;
export const isWeakMap = (value) => value instanceof WeakMap;
//# sourceMappingURL=type.js.map